"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageFrame = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
let ImageFrame = class ImageFrame extends core_1.DataFrame {
    /**
     * Height of image
     * @returns {number} Height
     */
    get rows() {
        return this.height;
    }
    set rows(value) {
        this.height = value;
    }
    /**
     * Width of image
     * @returns {number} Width
     */
    get cols() {
        return this.width;
    }
    set cols(value) {
        this.width = value;
    }
    /**
     * Source object clone that captured the data frame
     * @returns {CameraObject} Source data object
     */
    get source() {
        return super.source;
    }
    /**
     * Set the source object clone that captured the data frame
     * @param {CameraObject} object Source data object
     */
    set source(object) {
        super.source = object;
    }
};
exports.ImageFrame = ImageFrame;
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Object)
], ImageFrame.prototype, "image", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], ImageFrame.prototype, "height", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], ImageFrame.prototype, "width", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], ImageFrame.prototype, "fourcc", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], ImageFrame.prototype, "fps", void 0);
exports.ImageFrame = ImageFrame = tslib_1.__decorate([
    (0, core_1.SerializableObject)()
], ImageFrame);
//# sourceMappingURL=ImageFrame.js.map